import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { environment } from '../../../environments/environment';
import { CommonService } from '../../shared/services/common.service';
import { API_ENDPOINTS } from '../../core/services/api.service';
import { HttpClient } from '@angular/common/http';

@Injectable({
  providedIn: 'root'
})
export class CustomerService {


  constructor(public commonSvc: CommonService, private http: HttpClient) {
  }

  getAllCustomers(data: any): Observable<any> {
    return this.commonSvc.httpSvc.get<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.LISTING, data)
  }
  getCustomerById(id: any): Observable<any> {
    return this.commonSvc.httpSvc.getById<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.BY_ID, id)
  }
  getCount(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.REPORT.GET_COUNT, data)
  }
  getMissingTimestamp(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.REPORT.GET_MISSING_TIMESTAMP, data)
  }
  addCustomer(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.ADD, data)
  }
  updateCustomer(id: string | number, data: any): Observable<any> {
    return this.commonSvc.httpSvc.patch<any[]>(`${environment.apiBaseUrl}${API_ENDPOINTS.CUSTOMER.UPDATE}`, id, data)
  }
  getApplications(params: any): Observable<any> {
    let url = environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.APPLICATIONS;

    if (params && Object.keys(params).length > 0) {
      const queryString = Object.entries(params)
        .map(([key, value]) => `${key}=${encodeURIComponent(value as string)}`)
        .join('&');
      url += `?${queryString}`;
    }

    return this.commonSvc.httpSvc.get<any[]>(url);
  }
  addCustomerConfig(data: any): Observable<any> {
    return this.commonSvc.httpSvc.post<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.ADD_CONFIG, data)
  }
  // Update existing customer config (e.g. enable/disable feature) via PATCH on the same endpoint
  updateCustomerConfigStatus(id: string | number | '', data: any): Observable<any> {
    return this.commonSvc.httpSvc.patch<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.ADD_CONFIG, id, data);
  }
  getCustomerConfig(params: any): Observable<any> {
    console.log(params, "params");
    return this.commonSvc.httpSvc.get<any[]>(environment.apiBaseUrl + API_ENDPOINTS.CUSTOMER.GET_CONFIG + `?${Object.entries(params).map(([key, value]) => `${key}=${value}`).join('&')}`);
  }

}
